<script>
export default {
  name: 'NavigationList',
  props: {
    items: { type: Array, required: true },
    subheader: { type: String, default: () => '' }
  }
}
</script>

<template>
  <v-list shaped>
    <template v-for="(item, i) in items">
      <v-list-item
        v-if="item.visible !== false"
        :key="i"
        :to="item.route"
        color="primary"
        class="px-6"
        :link="!!item.action"
        v-on="item.action ? { click: item.action } : {}"
      >
        <v-list-item-icon class="ml-3 mr-6">
          <v-icon class="fa-fw" size="18" v-text="item.icon" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-medium body-2">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<style lang="sass" scoped>
.v-list-item:not(.v-list-item--active) .v-icon
  color: #78909C
</style>
